import { render, staticRenderFns } from "./advertisementadd.vue?vue&type=template&id=b0304c8a&scoped=true"
import script from "./advertisementadd.vue?vue&type=script&lang=js"
export * from "./advertisementadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0304c8a",
  null
  
)

export default component.exports